import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";

const Time = ({time, event}) => {

    const navigate = useNavigate();

    const convertTimeToHour = (time) => {
        return parseInt(time.split(":")[0], 10);
    }

    const convertTimeToMinutes = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
    }

    const timeToHour = convertTimeToHour(time);

    const filteredEvents = event?.events?.filter(event => {
        const eventTimeFrom = event.timeFrom.split(':').map(Number);
        const eventHour = eventTimeFrom[0];
    
        return eventHour >= timeToHour && eventHour < timeToHour+1;
    });

    const gotoEditMeeting = (meetingId, type) => {
        if (type === 'CALENDAR_TYPE_MEETING') {
            navigate('/calendar/edit-event/' + meetingId);
        }
    }

    return (
        <div className="calendar__timeline-column" data-hour={time}>
            <div className="calendar__timeline-hour">
                <div className="calendar__timeline-quarter"></div>
                <div className="calendar__timeline-quarter"></div>
                <div className="calendar__timeline-quarter"></div>
                <div className="calendar__timeline-quarter"></div>
            </div>
            {filteredEvents?.length > 0 &&
                filteredEvents?.map((filteredEvent, index) => {
                    const durationInMinutes = convertTimeToMinutes(filteredEvent.timeTo) - convertTimeToMinutes(filteredEvent.timeFrom);
                    return (
                        <div key={index} className="calendar__timeline-event" data-start={filteredEvent.timeFrom} data-end={filteredEvent.timeTo} onClick={() => gotoEditMeeting(filteredEvent.id, filteredEvent.type)}>
                            <div className="calendar__timeline-event-container">
                                <div className="calendar__timeline-event-title">{filteredEvent.title}</div>
                                <div className="calendar__timeline-event-timing">
                                    <span>{filteredEvent.timeFrom}</span>
                                    <span>{filteredEvent.timeTo}</span>
                                </div>
                                <div className="calendar__timeline-event-attendees">
                                {
                                    filteredEvent?.participants?.map((participant, index2) => {
                                        return (
                                            <>
                                                <div key={index2} className="calendar__timeline-event-attendee">
                                                    <span>{participant?.firstName?.charAt(0)}</span>
                                                    <span>{participant?.lastName?.charAt(0)}</span>
                                                </div>
                                            </>
                                        );
                                    })
                                }
                                </div>
                                <div className="calendar__timeline-event-duration">
                                    <span>{durationInMinutes} min</span>
                                </div>
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
};

export default Time;
